import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Order } from "../../OrderMFE/Orders/types/salesOrder";

/** Server-driven pagination for the sales order list (listOrders / listOrdersByStore). */
export interface SalesOrderListMeta {
  totalCount: number;
  totalPages: number;
  /** 0-based page index from the API. */
  page: number;
  pageSize: number;
}

export interface SalesOrderState {
  salesOrderList: Order[];
  salesOrderDetail: Order | null;
  salesOrderListMeta: SalesOrderListMeta | null;
}

const initialState: SalesOrderState = {
  salesOrderList: [],
  salesOrderDetail: null,
  salesOrderListMeta: null
};

export const salesOrderSlice = createSlice({
  name: "salesOrder",
  initialState,
  reducers: {
    setSalesOrderList: (state, action: PayloadAction<Order[]>) => {
      state.salesOrderList = action.payload;
    },
    setSalesOrderDetail: (state, action: PayloadAction<Order | null>) => {
      state.salesOrderDetail = action.payload;
    },
    resetSalesOrderDetail: (state) => {
      state.salesOrderDetail = null;
    },
    setSalesOrderListMeta: (
      state,
      action: PayloadAction<SalesOrderListMeta | null>
    ) => {
      state.salesOrderListMeta = action.payload;
    },
    clearSalesOrderList: (state) => {
      state.salesOrderList = [];
      state.salesOrderListMeta = null;
    },
    // Updates a single order in the list in-place (e.g. after status change)
    updateSalesOrderInList: (state, action: PayloadAction<Order>) => {
      const idx = state.salesOrderList.findIndex(
        (o) => o.orderId === action.payload.orderId
      );
      if (idx !== -1) {
        state.salesOrderList[idx] = action.payload;
      }
    }
  }
});

export const {
  setSalesOrderList,
  setSalesOrderListMeta,
  setSalesOrderDetail,
  resetSalesOrderDetail,
  clearSalesOrderList,
  updateSalesOrderInList
} = salesOrderSlice.actions;

export default salesOrderSlice.reducer;
